import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrdersRemainingService {

  constructor() { }

  getOrdersRemaining(): Observable<number> {
    return of(10);
  }
}
